import type { ViewportSignals } from "@/utils/ViewportClassification";

/**
 * PR31: the one place that reads the live browser signals
 * `classifyGameplayViewport()` (a pure function, deliberately with no
 * `window`/`matchMedia` access of its own - see that module's doc) needs.
 * Kept tiny and separate so the classification RULE stays fully unit-
 * testable without a browser, while this thin read-only wrapper is the
 * only part that ever touches `window`.
 */
export function readViewportSignals(): ViewportSignals {
  return {
    width: window.innerWidth,
    height: window.innerHeight,
    hasCoarsePointer: typeof window.matchMedia === "function" && window.matchMedia("(pointer: coarse)").matches,
    hasTouch: navigator.maxTouchPoints > 0 || "ontouchstart" in window,
  };
}
